const IconCancel = ({ className }: any) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={25} height={24} viewBox="0 0 25 24" fill="none">
    <path d="M6.5 18L18.4999 6.0001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.4999 17.9999L6.5 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default IconCancel;
